import React, { createContext, useContext } from 'react'

export type CallHeaderActions = {
  onOpenCallNotes: (callID: string, entryID?: string | null) => void
  showForProgram: (programID: string | undefined) => boolean
}

export type HostSlots = {
  renderCallHeader?: (uid: string, actions: CallHeaderActions) => React.ReactNode
}

const HostSlotsContext = createContext<HostSlots>({})

export const HostSlotsProvider = HostSlotsContext.Provider

export const useHostSlots = (): HostSlots => useContext(HostSlotsContext)
